// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__EA0Pb","active":"Footer_active__fAwR-","MadeIn":"Footer_MadeIn__OKkPk","Link":"Footer_Link__ACpAS"};